export interface Config {
  server: string;
}
